import React from 'react'
import Switch from 'antd/es/switch'
import {
  useGetAutoApproveSettings,
  useToggleAutoApprove,
} from '../hooks/useAutoApproveSettings'
import type { AutoApproveKey } from '../api/plan-override-settings-api'
import styles from './PlanOverridesComponents.module.scss'

interface Props {
  settingsKey: AutoApproveKey
}

export default function AutoApproveSwitch({ settingsKey }: Props) {
  const { data, isLoading } = useGetAutoApproveSettings()
  const { mutate, isPending } = useToggleAutoApprove(settingsKey)

  const checked = data?.[settingsKey] ?? false

  return (
    <span className={styles.autoApproveSwitch}>
      <span className={styles.autoApproveSwitchLabel}>Auto Approve</span>
      <Switch
        checked={checked}
        loading={isLoading || isPending}
        onChange={(value) => mutate(value)}
        size="small"
      />
    </span>
  )
}
